import {
  LoadLecturersAsync,
  LoadCourseNamesAsync,
  LoadLecturersCoursesAsync,
  ShowMyCartSummaryAsync,
} from './aka.js';
export async function mainlektori() {
  console.log('LoadLecturers');
  await LoadLecturersAsync();
  console.log('LoadLecturers awaited');
  await LoadCourseNamesAsync();
  await LoadLecturersCoursesAsync();
  await ShowMyCartSummaryAsync();
  console.log('LoadLecturers final');
}
